"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = amplitudeSubscriber;

var _utils = require("../utils");

var _excluded = ["amplitudeEvent", "actionType", "actionFlow"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var CORE_USER_PROPS = {
  package: 'userPackageId',
  packageName: 'userPackageName',
  subscriptionStatus: 'userSubscriptionStatus'
};
var CORE_USER_PROPS_KEYS = Object.keys(CORE_USER_PROPS);
var ONETRUST_FUNCTIONAL_COOKIE_GROUP = 'C0003';

var blockedByOneTrust = function blockedByOneTrust() {
  var overrideOneTrust = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _parseOneTrustCookie = (0, _utils.parseOneTrustCookie)(),
      hasOneTrustCookie = _parseOneTrustCookie.hasOneTrustCookie,
      oneTrustGroups = _parseOneTrustCookie.groups; // we are blocked by OneTrust if...


  return (// we're not overridden to _ignore_ OneTrust...
    !overrideOneTrust && // the OneTrust cookie is not present or does not have
    // functional cookies accepted
    !(hasOneTrustCookie && oneTrustGroups[ONETRUST_FUNCTIONAL_COOKIE_GROUP] === true)
  );
};

function amplitudeSubscriber(digitalDataEvent, config) {
  var _amplitudeRequire$def;

  var amplitudeToken = config.amplitudeToken,
      user = config.user,
      overrideOneTrust = config.overrideOneTrust;
  var digitalData = digitalDataEvent.data;

  var amplitudeEvent = digitalData.amplitudeEvent,
      actionType = digitalData.actionType,
      actionFlow = digitalData.actionFlow,
      data = _objectWithoutProperties(digitalData, _excluded);

  if ( // bail if we have no ampltude token
  !amplitudeToken || // or if this is not an amplitude event
  !amplitudeEvent || // or if OneTrust functional cookies haven't been accepted
  blockedByOneTrust(overrideOneTrust)) {
    return;
  }

  var userId = user.id,
      isAuthenticated = user.isAuthenticated,
      teamId = user.teamId,
      languageId = user.languageId; // we'll include the amplitude SDK here via "require" to avoid getting
  // yelled at by the test runner since amplitude makes explicit references
  // to "window", which doesn't exist in the test environment before we mock it
  // eslint-disable-next-line global-require

  var amplitudeRequire = require('amplitude-js'); // this is to catch a bundling issue that was introduced with amplitude-js@8.11.0
  // that used the ESM module instead of the default `main` import:
  // https://github.com/amplitude/Amplitude-JavaScript/commit/3e98d506f003ba428ab08796d1246ccb387d1f32


  var amplitude = (_amplitudeRequire$def = amplitudeRequire.default) !== null && _amplitudeRequire$def !== void 0 ? _amplitudeRequire$def : amplitudeRequire;

  try {
    var amplitudeInstance = amplitude.getInstance();
    amplitudeInstance.init(amplitudeToken, null, {
      includeReferrer: true
    });

    if (isAuthenticated) {
      // if the user belongs to a team, send that down as a group property
      // set this before the user props below so that group info is sent as part
      // of the user props call
      if (teamId) {
        amplitudeInstance.setGroup('teamId', teamId);
      }

      amplitudeInstance.setUserId(userId); // add in any core props if they're present on the user object

      var userProps = {
        languageId: languageId
      };
      CORE_USER_PROPS_KEYS.forEach(function (key) {
        var val = user[key];

        if (val && CORE_USER_PROPS[key]) {
          userProps[CORE_USER_PROPS[key]] = user[key];
        }
      });
      amplitudeInstance.setUserProperties(userProps);
    } else {
      // make sure we've cleared out the data for any previous logged in user
      amplitudeInstance.clearStorage();
    }

    amplitudeInstance.logEvent(amplitudeEvent, _objectSpread({}, data));
  } catch (err) {// silently fail; we don't want a bad metrics call taking the whole experience down
  }
}

module.exports = exports.default;